var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 10.6899C11.2804 10.6899 10.6904 11.2799 10.6904 11.9999C10.6904 12.7199 11.2804 13.3099 12.0004 13.3099C12.7204 13.3099 13.3104 12.7199 13.3104 11.9999C13.3104 11.2799 12.7204 10.6899 12.0004 10.6899Z",
    fill: "#8282FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00043 10.6899C6.28043 10.6899 5.69043 11.2799 5.69043 11.9999C5.69043 12.7199 6.28043 13.3099 7.00043 13.3099C7.72043 13.3099 8.31043 12.7199 8.31043 11.9999C8.31043 11.2799 7.72043 10.6899 7.00043 10.6899Z",
    fill: "#8282FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0004 10.6899C16.2804 10.6899 15.6904 11.2799 15.6904 11.9999C15.6904 12.7199 16.2804 13.3099 17.0004 13.3099C17.7204 13.3099 18.3104 12.7199 18.3104 11.9999C18.3104 11.2799 17.7204 10.6899 17.0004 10.6899Z",
    fill: "#8282FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.5a39c4db5a2f3822fdcc469287cd5b04.svg";
export { ForwardRef as ReactComponent };